import { Map as ImmutableMap } from 'immutable';

import { rootUiActions, rootUiTypes } from 'app-components/flux/root-ui';
import store from 'app-components/utils/redux-store';

import { ImportModalComponent } from 'components/RootModal/modalRegistry';

import useQDialogs from 'components/QDialogs/useQDialogs';
import { dialogOnClose } from './DialogOnClose';
import type { ScheduledTransactionEditDialogProps } from './ScheduledTransactionEditDialog';

export const SCHEDULED_TRANSACTION_DIALOG = 'SCHEDULED_TRANSACTION_DIALOG';
ImportModalComponent(SCHEDULED_TRANSACTION_DIALOG, () => import('./ScheduledTransactionEditDialog'));

export const closeScheduledTransactionEditDialog = () => {
  store?.dispatch(rootUiActions.removeDialog(SCHEDULED_TRANSACTION_DIALOG));
};

export const useScheduledTransactionEditDialog = () => {
  const { dialogAlert } = useQDialogs();
  return (props: Omit<ScheduledTransactionEditDialogProps, 'onClose'> & { onClose?: () => void }) => {
    const onClose = props.onClose ?? dialogOnClose(dialogAlert, closeScheduledTransactionEditDialog);

    store?.dispatch(
      rootUiActions.createDialog(
        rootUiTypes.mkRootUiData({
          id: SCHEDULED_TRANSACTION_DIALOG,
          type: SCHEDULED_TRANSACTION_DIALOG,
          props: ImmutableMap({ ...props, onClose }),
        }),
      ),
    );
  };
};

export default useScheduledTransactionEditDialog;
